import GavelStrikeIcon from './GavelStrikeIcon'

export default GavelStrikeIcon
